import USER_ROLES from './userRoles';
/**
 * TODO: Source this from BE
 *
 * Might rename to USER_ROLES later, but using this name to make it obvious what the intent is here because the old USER_ROLES were representing the user type (role_id/actor_type),
 * where "SYSTEM_PERMISSION_BUNDLE_TYPE" is representing the several roles a user can have at once (roles array).
 *
 * eg an admin actor_type user can be assigned a superAdmin SYSTEM_PERMISSION_BUNDLE_TYPE to give them elevated permissions compared to other admins
 */
export const SYSTEM_PERMISSION_BUNDLE_TYPE = {
    superAdmin: USER_ROLES.superAdmin,
    ptxSupportPartner: USER_ROLES.ptxSupportPartner,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3lzdGVtUGVybWlzc2lvbkJ1bmRsZVR5cGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy9zeXN0ZW1QZXJtaXNzaW9uQnVuZGxlVHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxVQUFVLE1BQU0sYUFBYSxDQUFDO0FBRXJDOzs7Ozs7O0dBT0c7QUFDSCxNQUFNLENBQUMsTUFBTSw2QkFBNkIsR0FBRztJQUMzQyxVQUFVLEVBQUUsVUFBVSxDQUFDLFVBQVU7SUFDakMsaUJBQWlCLEVBQUUsVUFBVSxDQUFDLGlCQUFpQjtDQUNOLENBQUMifQ==